import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardAddComponent } from './card-add/card-add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { paymentRoutes } from './payment.route';
import { SelectCardComponent } from './select-card/select-card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PaymentSelectionComponent } from './payment-selection/payment-selection.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { PaymentSelectionModule } from './payment-selection/payment-selection.module';
import { AddCardComponent } from './add-card/add-card.component';
import { SharedCommonModule } from '../../shared/shared-common.module';
import { NgxMaskModule } from 'ngx-mask';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { ThreedComponent } from './threed/threed.component';
import { NzAlertModule, NzSpinModule, NzStatisticModule } from 'ng-zorro-antd';
import { SmsComponent } from './sms/sms.component';
import { PinComponent } from './pin/pin.component';
import { OtpComponent } from './otp/otp.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { LayoutModule } from '../../layout/layout.module';


@NgModule({
  declarations: [CardAddComponent, SelectCardComponent, PaymentSelectionComponent, AddCardComponent, ThreedComponent, SmsComponent, PinComponent, OtpComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forChild(paymentRoutes),
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    NgbCollapseModule,
    PaymentSelectionModule,
    SharedCommonModule,
    NgxMaskModule,
    CreditCardDirectivesModule,
    NzAlertModule,
    NzStatisticModule,
    NgOtpInputModule,
    NzSpinModule,
    LayoutModule
  ],
  exports: [CardAddComponent, SelectCardComponent, PaymentSelectionComponent, AddCardComponent, ThreedComponent, SmsComponent, PinComponent, OtpComponent]
})
export class PaymentModule {
}
